import React, { useState } from "react";
import styles from "./beneficiary.module.css";
import Input from "../../Common/V2/Widgets/Input/index";
import Button from "../../Common/Button";
import DropDown from "../../Common/DropDown";
import { formatAmountWithDecimal } from "../../../src/Constants/helper";
import { PURPOSE_OPTIONS } from "../../../src/utils/utils";

const TransferStep1 = ({
  lienAccountNo,
  unlienAccountNo,
  lienBalance = 0,
  userName = "",
  onNext,
  onCancel,
  formData,
  setFormData,
  transferType = "UNLIEN",
  purposeOptions = PURPOSE_OPTIONS,
}) => {
  const [localAmount, setLocalAmount] = useState("");
  const [localRemarks, setLocalRemarks] = useState("");
  const [errors, setErrors] = useState({});
  const amount = formData ? formData.amount : localAmount;
  const remarks = formData ? formData.remarks : localRemarks;

  const getAmountExceededMessage = () =>
    `Amount cannot exceed ${
      transferType === "EMI" ? "unlien balance" : "lien balance"
    } (${formatAmountWithDecimal(lienBalance)})`;

  const validate = () => {
    const newErrors = {};
    const parsedAmount = parseFloat(amount);

    if (!amount || amount.toString().trim() === "") {
      newErrors.amount = "Amount is required";
    } else if (isNaN(parsedAmount) || parsedAmount <= 0) {
      newErrors.amount = "Amount must be greater than 0";
    } else if (parsedAmount > parseFloat(lienBalance)) {
      newErrors.amount = getAmountExceededMessage();
    }

    if (!remarks.trim()) {
      newErrors.remarks = "Remarks is required";
    }
    if (transferType === "EMI" && !formData?.purpose?.trim()) {
      newErrors.purpose = "Purpose is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const formatCurrency = (val) => {
    if (!val && val !== 0) return "";
    const str = val.toString().replace(/,/g, "");
    const parts = str.split(".");
    parts[0] = new Intl.NumberFormat("en-US").format(parts[0] || 0);
    return parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
  };

  const balanceLabel =
    transferType === "EMI" ? "unLien balance" : "lien balance";

  const handleAmountChange = (e) => {
    let val = e.target.value;

    val = val.replace(/\$/g, "").replace(/,/g, "").trim();
    if (!/^\d*\.?\d*$/.test(val)) {
      return;
    }

    if (setFormData) {
      setFormData((prev) => ({ ...prev, amount: val }));
    } else {
      setLocalAmount(val);
    }

    if (errors.amount) {
      const parsedAmount = parseFloat(val);
      if (!val) {
        setErrors((prev) => ({ ...prev, amount: "Amount is required" }));
      } else if (isNaN(parsedAmount) || parsedAmount <= 0) {
        setErrors((prev) => ({
          ...prev,
          amount: "Amount must be greater than 0",
        }));
      } else if (parsedAmount > parseFloat(lienBalance)) {
        setErrors((prev) => ({
          ...prev,
          amount: getAmountExceededMessage(),
        }));
      } else {
        setErrors((prev) => ({ ...prev, amount: undefined }));
      }
    }
  };

  const handleRemarksChange = (e) => {
    const val = e.target.value;
    if (setFormData) {
      setFormData((prev) => ({ ...prev, remarks: val }));
    } else {
      setLocalRemarks(val);
    }
    if (errors.remarks) {
      setErrors((prev) => ({
        ...prev,
        remarks: val.trim() ? undefined : "Remarks is required",
      }));
    }
  };

  const handleNext = () => {
    if (validate()) {
      onNext({ amount, remarks });
    }
  };

  return (
    <div className={styles.lienTransferForm}>
      <div className={styles.formScrollArea}>
        <div className={styles.nameContainer}>
          <div className={styles.left}>
            <div className={styles.infoLabel}>Name</div>
            <div className={styles.infoValue}>{userName || "—"}</div>
          </div>
          <div className={styles.right}>
            <div className={styles.infoLabel}>
              {transferType === "EMI" ? "Unlien Balance" : "Lien Balance"}
            </div>
            <div className={styles.infoValue}>
              {formatAmountWithDecimal(lienBalance)}
            </div>
          </div>
        </div>
        {transferType !== "EMI" && (
          <div className={styles.sectionHint}>
            How much amount you want to Unlien?
          </div>
        )}
        <div className={styles.formmargin}>
          <Input
            required
            label="Enter Amount"
            placeholder="Enter Amount"
            type="text"
            name="amount"
            value={amount ? `$ ${formatCurrency(amount)}` : "$ "}
            onChange={handleAmountChange}
            error={errors.amount}
            helperText={errors.amount}
          />

          <DropDown
            required
            label="Purpose"
            name="purpose"
            value={
              transferType === "EMI"
                ? formData?.purpose
                : formData?.purpose || "Lien Release"
            }
            data={purposeOptions}
            onChange={(selected) => {
              setFormData((prev) => ({
                ...prev,
                purpose: selected?.value || selected,
              }));

              if (errors.purpose) {
                setErrors((prev) => ({
                  ...prev,
                  purpose: undefined,
                }));
              }
            }}
            disabled={transferType !== "EMI"}
            isSearchable={false}
            showClearButton={transferType === "EMI"}
            error={transferType === "EMI" ? errors.purpose : undefined}
            helperText={transferType === "EMI" ? errors.purpose : undefined}
            placeholder="Select a purpose"
          />

          <Input
            required
            label="Remarks"
            placeholder="Enter Remarks"
            type="text"
            name="remarks"
            value={remarks}
            onChange={handleRemarksChange}
            error={errors.remarks}
            helperText={errors.remarks}
          />
        </div>
      </div>

      <div className={styles.formFooter}>
        <div className={styles.footerRow}>
          <div className={styles.footerCol}>
            <Button
              onClick={onCancel}
              title={
                transferType === "EMI" ? "Cancel Deduction" : "Cancel Transfer"
              }
            />
          </div>
          <div className={styles.footerCol}>
            <Button

              onClick={handleNext}
              title={
                transferType === "EMI"
                  ? "Verify EMI Deduction Details"
                  : "Verify Transfer Details"
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferStep1;
